export default function () {

  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper">
      </div>
      <div class="swiper-pagination desktop-pagination"></div>
    </div>
  
    <div class="swiper-container swiper-container-content">
      <div class="swiper-wrapper">
      
      </div>
     
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-pagination mobile-pagination"></div>
    </div>
  `;


  // Slide Template - Images
  function buildSlideTemplateImages(slide) {

    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

    return template;
  }

  // Slide Template - Content
  function buildSlideTemplateContent(slide) {

    const title = `<span class="slide-title">${slide.Title}</span>`;
    const description = slide.Description ? `<p>${slide.Description}</p>` : '';

    const buttons = function (btn1, btn1Text, btn2, btn2Text) {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');
        if (btn2) {
          btnContainer.append(`<a href="${btn2}" class="button">${btn2Text}</a>`);
        }
        if (btn1) {
          btnContainer.append(`<a href="${btn1}" class="button">${btn1Text} </a>`);
        }
        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    }

    const template = `
      <div class="swiper-slide">
        <div class="swiper-content-container">
          <div class="title-description">
            ${title}
            ${description}
          </div>
          ${buttons(slide.URL, slide.DetailLinkText, slide.PurchaseURL, slide.PurchaseLinkText)}
        </div>
      </div>
    `;

    return template;
  }


  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);
    const swiperWidgetContentWrapper = $(`#${widgetName} .swiper-container-content .swiper-wrapper`);

    widgetData.forEach(function (slide, i) {
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
    });

    const swiperWidgetImages = new Swiper(`#${widgetName} .swiper-container-images`, {
      speed: 600,
      autoplay: {
        delay: 8000,
      },
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      a11y: true,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });

    const swiperWidgetContent = new Swiper(`#${widgetName} .swiper-container-content`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      a11y: true,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });

    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;

  }


  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
      // console.log(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
  // setTimeout(function() {
  //   if ($('#swiperWidget .swiper-container')[0]) {
  //     $('.swiper-widget-main').show();
  //     }
  //   else {
  //     $('.swiper-widget-main').hide();
  //     $("body").addClass("slideshowhide");
  //   }
  // }, 1000);
  // setTimeout(function() {
  //   if ($('#swiperWidget .swiper-container')[0]) {
  //     $('body').addClass('swiperactive');
  //   }
  // }, 1000);
  setTimeout(function() {
    var swiper = document.getElementById("swiperWidget");
    if (swiper.innerHTML.trim() === "") {
        // Add a class to the body element
        document.body.classList.add("swiper-empty");
    }
  }, 2000);
}
